import React from "react";

import "./textarea.styles.css";

const Textarea = ({
  label,
  placeholder,
  inputClassname,
  withError,
  onChange,
  errorMessage
}) => {
  const classnames = withError ? `${inputClassname} hasError` : inputClassname;
  return (
    <div className="textarea__container">
      <label>{label}</label>
      <textarea
        placeholder={placeholder}
        className={classnames}
        onChange={onChange}
      ></textarea>
      {withError && <span>{errorMessage}</span>}
    </div>
  );
};

export default Textarea;
